import { render, staticRenderFns } from "./blacklistList.vue?vue&type=template&id=ddedd706&scoped=true&"
import script from "./blacklistList.vue?vue&type=script&lang=js&"
export * from "./blacklistList.vue?vue&type=script&lang=js&"
import style0 from "./blacklistList.vue?vue&type=style&index=0&id=ddedd706&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddedd706",
  null
  
)

export default component.exports